/** Format helpers used by the report UI. */

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—"
  const d = new Date(iso)
  // Sprint dates are date-only (YYYY-MM-DD), which Date parses as UTC midnight.
  // Format in UTC so the displayed calendar date matches the stored value
  // regardless of the viewer's timezone (otherwise UTC-N zones show a day early).
  return d.toLocaleDateString("en-CA", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    timeZone: "UTC",
  })
}

export function formatRelativeMinutes(timestampMs: number): string {
  const seconds = Math.floor((Date.now() - timestampMs) / 1000)
  if (seconds < 60) return `${seconds}s ago`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} min ago`
  const hours = Math.floor(minutes / 60)
  return `${hours}h ${minutes % 60}m ago`
}

export function dashIfZero(value: number): string {
  return value === 0 ? "—" : String(value)
}
